import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as appActions from '../actions/appactions';
import * as workFlowAction from '../modules/workflow/actions/workflowactions';
import * as securityActions from '../actions/securityactions'
import * as appUtilityFunction from '../infrastructure/apputilityfunctions'


export default function Notification() {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.workFlowReducer);

    let pageMenuId = appUtilityFunction.getUrlParameter('pageId');
    useEffect(() => {

        dispatch(securityActions.checkAccess({ pageMenuId }));
        getNotifications();
        const interval = setInterval(() => {
            // Call your function here
            getNotifications();
        }, 30 * 1000); // 2 minutes in milliseconds
        // Clean up the interval on component unmount
        return () => {
            clearInterval(interval);
        };
    }, []); 

    function getNotifications() {
        dispatch(workFlowAction.getNotifications());
    }
    const showWorkFlow = (processSessionId) => {
        dispatch(workFlowAction.getApprovalDetails(processSessionId));
        dispatch(workFlowAction.showWorkFlow(true));
    }
    let pendingCount = state.approvalLog && state.approvalLog.filter(entry => entry.status === null).length;
    let approvedCount = state.approvalLog && state.approvalLog.filter(entry => entry.status != null).length;

    return (

        <li class="dropdown notification-list" onClick={(event) => event.stopPropagation()} >
            <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                <i class="dripicons-bell noti-icon"></i>
                {state.approvalLog && state.approvalLog.filter(entry => entry.status === null).length > 0 ?
                    <span class="noti-icon-badge"></span> : ''
                }
                {pendingCount > 0 &&
                    <span
                        class="position-absolute bottom-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {pendingCount}
                        <span class="visually-hidden">unread messages</span>
                    </span>
                }
            </a>

            <div class="dropdown-menu dropdown-menu-end dropdown-menu-animated dropdown-lg">
                <div class="dropdown-item noti-title px-3">
                    <h5 class="m-0">
                        <span class="float-end">
                        </span>Notifications
                    </h5>
                </div>

                <div class="px-3" style={{ "height": "70vh" }} data-simplebar>

                    <ul class="nav nav-tabs nav-justified nav-bordered mb-3">
                        <li class="nav-item">
                            <a href="#pending" data-bs-toggle="tab" aria-expanded="true" class="nav-link rounded-0 active">
                                <i class="mdi mdi-home-variant d-md-none d-block"></i>

                                <span class="d-none d-md-block greyColor">Pending {pendingCount > 0 && <span class="badge bg-danger"> {pendingCount}</span>} </span>

                            </a>

                        </li>
                        <li class="nav-item">
                            <a href="#approved" data-bs-toggle="tab" aria-expanded="false" class="nav-link rounded-0">
                                <i class="mdi mdi-account-circle d-md-none d-block"></i>
                                <span class="d-none d-md-block greyColor">
                                    Approved {approvedCount > 0 && <span class="badge bg-success">{approvedCount}</span> }</span>
                            </a>
                        </li>

                    </ul>

                    <div class="tab-content" >
                        <div class="tab-pane show active" id="pending">
                            <p>

                                {state.approvalLog && state.approvalLog.filter(entry => entry.status === null).length > 0 ? (
                                    // Rendered if there is at least one entry with null status
                                    state.approvalLog.map(entry => {
                                        if (entry.status === null) {
                                            return (
                                                <a key={entry.id} onClick={() => showWorkFlow(entry.processSessionId)}
                                                    className="dropdown-item p-0 notify-item card unread-noti shadow-none mb-2">
                                                    <div className="card-body">

                                                        <div className="d-flex align-items-center">
                                                            <div className="flex-shrink-0">
                                                                <div className="notify-icon bg-danger">
                                                                    <i className="mdi mdi-comment-account-outline"></i>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 text-truncate ms-2" >
                                                                <h5 className="noti-item-title fw-semibold font-14" >
                                                                    {entry.statusText}
                                                                </h5>
                                                                <small className="noti-item-subtitle text-muted">{entry.description}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            );
                                        }
                                        return null;
                                    })
                                ) : (
                                    // Rendered if there are no entries with null status
                                    <a className="dropdown-item p-0 notify-item card unread-noti shadow-none mb-2">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="notify-icon bg-danger">
                                                        <i className="mdi mdi-information"></i>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 text-truncate ms-2" >
                                                    <small className="noti-item-subtitle">There are no pending approvals.</small>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )}

                            </p>
                        </div>


                        <div class="tab-pane" id="approved">
                            <p>

                                {state.approvalLog && state.approvalLog.filter(entry => entry.status != null).length > 0 ? (
                                    // Rendered if there is at least one entry with null status
                                    state.approvalLog.map(entry => {
                                        if (entry.status != null) {
                                            return (
                                                <a key={entry.id} onClick={() => showWorkFlow(entry.processSessionId)}
                                                    className="dropdown-item p-0 notify-item card unread-noti shadow-none mb-2">
                                                    <div className="card-body">
                                                        <div className="d-flex align-items-center">
                                                            <div className="flex-shrink-0">
                                                                <div className="notify-icon bg-success">
                                                                    <i className="mdi mdi-comment-account-outline"></i>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 text-truncate ms-2">
                                                                <h5 className="noti-item-title fw-semibold font-14">
                                                                    {entry.statusText}
                                                                </h5>
                                                                <small className="noti-item-subtitle text-muted">{entry.description}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            );
                                        }
                                        return null;
                                    })
                                ) : (
                                    // Rendered if there are no entries with null status
                                    <a className="dropdown-item p-0 notify-item card unread-noti shadow-none mb-2">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="notify-icon bg-success">
                                                        <i className="mdi mdi-information"></i>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 text-truncate ms-2" >

                                                    <small className="noti-item-subtitle">There are no approved items.</small>

                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                )}



                            </p>
                        </div>

                    </div>
                </div>


            </div>
        </li >
    )
}
